import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * Shows the room code plus a QR of the PRESENTER join URL, generated locally (no
 * external service). The talent scans it on the tablet to join hands-free — no
 * typing, which also sidesteps the on-screen-keyboard issue.
 */
export function RoomCode({ roomCode }: { roomCode: string }) {
  const joinUrl = `${window.location.origin}/presenter?room=${roomCode}`;
  const [qr, setQr] = useState<string>('');

  useEffect(() => {
    QRCode.toDataURL(joinUrl, { margin: 1, width: 220 })
      .then(setQr)
      .catch(() => setQr(''));
  }, [joinUrl]);

  return (
    <div className="row" style={{ gap: '1.25rem', alignItems: 'center' }}>
      <div className="stack" style={{ gap: '0.25rem' }}>
        <span className="muted">Room code</span>
        <span className="roomcode">{roomCode}</span>
        <span className="muted" style={{ fontSize: '0.85rem' }}>
          Talent: open <strong>/presenter</strong> and enter this code, or scan →
        </span>
      </div>
      {qr && <img className="qr" src={qr} alt={`QR code to join room ${roomCode}`} width={132} height={132} />}
    </div>
  );
}
